import { FunctionComponent, useMemo } from 'react';
import { formatDateLong, formatDateRelative } from 'lib/date';
import {
  TimelinePointBody,
  TimelinePointBodyContent,
  TimelinePointHeader,
  TimelinePointIcon,
  TimelinePointLabel,
  TimelinePointLine,
  TimelinePointTime,
} from './TimelinePoint.styled';
import { TimelinePointProps } from './types';

export const TimelinePoint: FunctionComponent<TimelinePointProps> = props => {
  const { caption, children, color, date, icon } = props;

  // Timeline point message (body)
  const pointBody = useMemo(
    () =>
      children && (
        <TimelinePointBody>
          <TimelinePointLine />
          <TimelinePointBodyContent>{children}</TimelinePointBodyContent>
        </TimelinePointBody>
      ),
    [children],
  );

  // Timeline point date/time
  const pointTime = useMemo(
    () =>
      date && (
        <TimelinePointTime title={formatDateLong(date, true)}>
          {formatDateRelative(date)}
        </TimelinePointTime>
      ),
    [date],
  );

  return (
    <>
      <TimelinePointHeader>
        <TimelinePointIcon $color={color} name={icon} />
        <TimelinePointLabel>{caption}</TimelinePointLabel>
        {pointTime}
      </TimelinePointHeader>
      {pointBody}
    </>
  );
};
